import React, {useContext, useEffect, useState} from "react";
import '../ClientInvoice/ClientInvoice.css'
import SignPadForEsigns from "../CommonComponents/SignPadForEsigns";
import {RecordsManagementContext,ViewMangementContext} from "../StatesMangement/InitialiseContext";
import parse from 'html-react-parser';
import './Common.css'
import {Modal} from "react-bootstrap";
import {
    Elink, SaveEstimateAddendumValues, SaveRadioButtonsValue, SaveClientPortalAddendum, UnsubmitAddendumData,
    DeleteAddendumSign
} from "./Routes";
import axios from "axios";
import swal from "sweetalert";
export default () => {//component is used to show addendum
    let Record = useContext(RecordsManagementContext)
    let  backgroundColor1 = Record.CP_PageDetails.EstimateAndCompanyInfo.Estimate.BgColor1 // used to set the background color of the client portal according to the setting in moveitpro.
    let  backgroundColor2 = Record.CP_PageDetails.EstimateAndCompanyInfo.Estimate.BgColor2
    let PageView = useContext(ViewMangementContext)
    let data = Record.CP_PageDetails.EstimateDetails.JobDetails
    data = data.JobDetails == undefined ? data : data.JobDetails
    let EstimateAddendum = data.EstimateAddendum
    let cookie = document.cookie.split('employee_id=')[1]
    let [EsignFor , setEsignFor ] = useState('')
    let element3 = document.getElementsByClassName('portal-radio-btn')
    const OpenSignaturePad = async (For, signed_from = "EstimateAddendum", addendum_id = Record.SelectedAddendum) => {
        Record.setESignModal(true) //modal will open for esigns when set value true
        setEsignFor({ id: For, signed_from, addendum_id }) // set the id and signed_from in EsignFor state
    }
    const SaveTextFieldsValue = (value, For, addendum_id) => { //save text values ,hit goes to the "save_estimate_addendum_values" function in the "client_portal_controller"
        var url = SaveEstimateAddendumValues
        axios({
            method: 'post',
            url: url,
            contentType: "application/json",
            params: {
                estimate_key: Elink,
                type: For.replace("portal", ''),
                value: value,
                set_for: "EstimateAddendum",
                addendum_id: addendum_id
            }
        }).then(res => {
        })
    }
    const SaveRadioValue = (id,name) => {
        axios({
            method: 'post',
            url: SaveRadioButtonsValue,
            contentType: "application/json",
            params: {
                estimate_key: Elink,
                content: id,
                content_type: name,
                set_for: "EstimateAddendum",
                addendum_id: Record.SelectedAddendum
            }}).then((response) => {
        }).catch(() => {
        })

    }


    useEffect(() => {//used to make header of the page sticky.
        // Select elements with class 'esign' and 'reqsign'
        const esignElements = document.getElementsByClassName('esign');
        const reqsignElements = document.getElementsByClassName('rqsign');
        // Add click event listeners to both sets
        for (let i = 0; i < esignElements.length; i++) {
            if (esignElements[i] != null) {
                esignElements[i].addEventListener('click', function (evt) {
                    let target = evt.target.id;
                    OpenSignaturePad(target, "EstimateAddendum", Record.SelectedAddendum);
                })
            }
        }
        for (let i = 0; i < reqsignElements.length; i++) {
            if (reqsignElements[i] != null) {
                reqsignElements[i].addEventListener('click', function (evt) {
                    let target = evt.target.id;
                    OpenSignaturePad(target, "EstimateAddendum", Record.SelectedAddendum);
                })
            }
        }
        for (let i = 0; i < element3.length; i++) {
            if (element3[i] != null) {
                element3[i].addEventListener('change', function (evt)  {
                    let targetRadioButtonId = evt.target.id
                    let targetRadioButtonName = evt.target.name
                    SaveRadioValue(targetRadioButtonId,targetRadioButtonName)
                })

            }
        }
        for (let i = 1; i <= 100; i++) {//fetched the text fields and checkboxes by there id's and save the values or text
            let element = document.getElementById(`textfield${i}`)
            let textArea = document.getElementById(`textarea${i}`)
            let checkBox = document.getElementById(`checkbox${i}`)
            if (element !== null) {
                element.addEventListener('change', (e)=> { SaveTextFieldsValue(e.target.value, `textfield${i}`, Record.SelectedAddendum) })
            }
            if (textArea !== null) {
                textArea.addEventListener('change', (e)=> { SaveTextFieldsValue(e.target.value, `textarea${i}`, Record.SelectedAddendum) })
            }
            if (checkBox !== null) {
                checkBox.addEventListener('change', (e)=> { SaveTextFieldsValue(e.target.checked, `checkbox${i}`, Record.SelectedAddendum) })
            }
        }
        window.addEventListener('scroll', isSticky);
        return () => {
            window.removeEventListener('scroll', isSticky);
        };
    });

    const buttonData = <svg xmlns="http://www.w3.org/2000/svg" width="36" height="31" fill="currentColor"
                            className="bi bi-arrow-left-square-fill" viewBox="0 0 16 16" onClick={()=>ShowEstimate()}>
        <title>Go To Estimate</title>
        <path d="M16 14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12zm-4.5-6.5H5.707l2.147-2.146a.5.5 0 1 0-.708-.708l-3 3a.5.5 0 0 0 0 .708l3 3a.5.5 0 0 0 .708-.708L5.707 8.5H11.5a.5.5 0 0 0 0-1z"/>
    </svg>
    const ShowEstimate = () => { // set the page view (either Invoice 1 or 2 )
        Record.setSelectedAddendum('')
        PageView.Set('CLIENT_PORTAL')
    }
    const isSticky = (e) => {//when scroll the page the header still shown on the page.
        const header = document.querySelector('.is-sticky');
        const scrollTop = window.scrollY;
        scrollTop  > 0 ? header.setAttribute('style', 'height: 50px; top: 0; border-bottom: #17a2b8 2px solid !important;margin-left: -23px;')  :
            header.setAttribute('style', 'height: 50px; top: 0; border-bottom: 0px;margin-left: -23px;;');
    };

    const handleModal = () => {
        Record.setESignModal(false) //close esign modal
    }

    // Submit button handler
    const handleSubmit = async (e) => {
        e.preventDefault();
        const reqSignElements = document.getElementsByClassName('rqsign');
        if (reqSignElements.length > 0) {
            swal("Required Sign is missing. Please provide all required signatures before submitting the addendum.");
            return;
        }
        try {
            await axios({
                method: 'post',
                url: SaveClientPortalAddendum,
                contentType: "application/json",
                params: {
                    estimate_key: Elink,
                    addendum_id: Record.SelectedAddendum,
                    submit_addendum: true
                }
            });
            window.location.reload();
        } catch (error) {
            swal("Error submitting addendum. Please try again.");
        }
    };

    const handleUnsubmit = async () => {
        try {
            await axios({
                method: 'post',
                url: UnsubmitAddendumData,
                contentType: "application/json",
                params: {
                    estimate_key: Elink,
                    addendum_id: Record.SelectedAddendum
                }
            });
            window.location.reload();

        } catch (error) {
            swal("Error un-submitting addendum. Please try again.");
        }
    };
    // Remove signature handler
    const handleRemoveSignature = async (e) => {
        const signatureId = e.target.getAttribute('data-id');
        Record.setSignatureLoad(true) //show loader
        await axios({
            method: 'post',
            url: DeleteAddendumSign,
            contentType: "application/json",
            params: {
                estimate_key: Elink,
                signature_id: signatureId,
                addendum_id: Record.SelectedAddendum
            }
        }).then(response => {
            Record.SetCP_PageDetails({
                ...Record.CP_PageDetails,
                EstimateDetails: response.data.EstimateDetails,
            });
            Record.setSignatureLoad(false)
        })
    };

    const getRemoveSignatureElements = () => {
        const removeSignatureElements = document.getElementsByClassName('remove-signature');
        for (let i = 0; i < removeSignatureElements.length; i++) {
            if (removeSignatureElements[i] != null) {
                removeSignatureElements[i].addEventListener('click', function (evt) {
                    handleRemoveSignature(evt);
                })
            }
        }
    }

    useEffect(() => {
        getRemoveSignatureElements();
    });
    return(
        <>
            <div style={{backgroundColor: "#172b4d", backgroundImage:  `linear-gradient(45deg, ${backgroundColor1} 15%, ${backgroundColor2} 85%)`, height: "100vh", overflow: "auto"}}>
                <div className='width-wrapper px-4'>
                    <table className="table">

                        <thead className={"is-sticky width-wrapper addendum_header set-bottom"} style={{ top: 0, paddingBottom: "3%", marginLeft: "-23px", textAlign: "center" }}>
                        <tr>
                            <th  className="td-main-bost wid-sticky" style={{paddingTop: "0px",width:"18.7%"}} colSpan={4} >
                                <table className="table">
                                    <tbody>
                                    <tr >
                                        <td style={{float: "left",borderTop:0}}>
                                            {buttonData}
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </th>
                        </tr>
                        </thead>
                        <tbody>

                        <tr>
                            <td colSpan={4} className="addendum-body" style={Record.SignatureLoad ? {
                                pointerEvents: "none", opacity: "0.3",zIndex:800
                            } : {}}>
                                {Object.keys(EstimateAddendum).map((addendum_name,key) => {
                                    if (EstimateAddendum[addendum_name].id === parseInt(Record.SelectedAddendum)){
                                        return <React.Fragment key={key}>{parse(`${EstimateAddendum[addendum_name].data}`)}</React.Fragment>;
                                    }

                                })}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <div className= {"border-top"} style={{width: "100%", display: "flex", justifyContent: "center", marginTop: "32px"}}>
                        <button
                            type="submit"
                            className="btn btn-primary mb-3 mt-2 fs-3"
                            onClick={handleSubmit}
                            disabled={Record.Disblebutton === "true" || Record.Disblebutton === true}
                        >
                            Submit
                        </button>
                        {Record.showUnsubmitButton === "true" || Record.showUnsubmitButton === true ? (
                            <button type="button" className="btn btn-primary mb-3 ml-3 mt-2 fs-2" onClick={handleUnsubmit}>Un Submit</button>
                        ) : null}
                    </div>
                </div>
            </div>
            <Modal show={Record.ESignModal} onHide={()=>handleModal()} className={
                'sign_estimate_modal'}
                   style={{top: "16%"}}>
                <Modal.Header ><h5 style={{color: "#37abdb", fontSize: "15px", fontWeight: 600}}>
                    Signature Pad </h5>
                    <button onClick={handleModal}
                            style={{color: "red",background: "white",border: "white" , height: "5%"}}>
                        <b className = "contactInfoCloseBtn" >X</b></button></Modal.Header>
                <Modal.Body> <SignPadForEsigns For={EsignFor}/></Modal.Body>
            </Modal>
        </>
    )
}